export const modulesData = [
  {
    id: 1,
    icon: "dashboard",
    name: "My Dashboard",
    link: "/my-dashboard",
    variant: "primary-soft-outline",
    subTitle: "Analytics",
    menu: "my-dashboard",
  },
  {
    id: 2,
    icon: "list-check",
    name: "CRM",
    link: "/home-ecommerce",
    variant: "secondary-soft-outline",
    subTitle: "CRM reports",
    menu: "crm",
  },
  {
    id: 3,
    icon: "wallet-saving",
    name: "Procurement",
    link: "/procurement-dashboard",
    variant: "success-soft-outline",
    subTitle: "Procurement Dashboard",
    menu: "procurement",
  },
  {
    id: 4,
    icon: "sign-inr",
    name: "Sales",
    link: "/home-project",
    variant: "danger-soft-outline",
    subTitle: "Sales Dashboard",
    menu: "sales",
  },
  {
    id: 5,
    icon: "building",
    name: "Inventory",
    link: "/inventory-dashboard",
    variant: "warning-soft-outline",
    subTitle: "Inventory Dashboard",
    menu: "inventory",
  },
  {
    id: 6,
    icon: "user",
    name: "Accounts",
    link: "/home-marketing",
    variant: "info-soft-outline",
    subTitle: "Accounts Dashboard",
    menu: "accounts",
  },
  {
    id: 7,
    icon: "package-fill",
    name: "Production",
    link: "/home-nft",
    variant: "light-soft-outline",
    subTitle: "Production Dashboard",
    menu: "production",
  },
  {
    id: 8,
    icon: "users",
    name: "HR",
    link: "/hr-dashboard",
    variant: "dark-soft-outline",
    subTitle: "HR Dashboard",
    menu: "hr",
  },
  {
    id: 9,
    icon: "truck",
    name: "Supply",
    link: "/supply-dashboard",
    variant: "white-soft-outline",
    subTitle: "Supply Dashboard",
    menu: "supply",
  },
  {
    id: 10,
    icon: "opt-dot-alt",
    name: "Settings",
    link: "/setting-dashboard",
    variant: "primary-soft-outline",
    subTitle: "Settings Dashboard",
    menu: "settings",
  },
  {
    id: 11,
    icon: "reports",
    name: "Reports",
    link: "/report-dashboard",
    variant: "secondary-soft-outline",
    subTitle: "Reports Dashboard",
    menu: "reports",
  },
  {
    id: 12,
    icon: 'user',
    name: 'Admin',
    link: '/admin',
    variant:'primary-soft-outline',
    subTitle:'Admin Dashboard',
    menu:'admin'
}
];

export const crmModulesData = [
  {
    id: 1,
    icon: "dashboard",
    name: "My Dashboard",
    link: "/my-dashboard",
    variant: "primary-soft-outline",
    subTitle: "Analytics",
    menu: "my-dashboard",
  },
  {
    id: 2,
    icon: "list-check",
    name: "CRM",
    link: "/home-ecommerce",
    variant: "secondary-soft-outline",
    subTitle: "CRM reports",
    menu: "crm",
  },
  {
    id: 3,
    icon: "users",
    name: "HR",
    link: "/hr-dashboard",
    variant: "success-soft-outline",
    subTitle: "HR Dashboard",
    menu: "hr",
  },
  {
    id: 4,
    icon: "reports",
    name: "Reports",
    link: "/report-dashboard",
    variant: "danger-soft-outline",
    subTitle: "Reports Dashboard",
    menu: "reports",
  },
];

export const accountsModulesData = [
  {
    id: 1,
    icon: "dashboard",
    name: "My Dashboard",
    link: "/my-dashboard",
    variant: "primary-soft-outline",
    subTitle: "Analytics",
    menu: "my-dashboard",
  },
  {
    id: 2,
    icon: "wallet-saving",
    name: "Procurement",
    link: "/procurement-dashboard",
    variant: "secondary-soft-outline",
    subTitle: "Procurement Dashboard",
    menu: "procurement",
  },
  {
    id: 3,
    icon: "sign-inr",
    name: "Sales",
    link: "/home-project",
    variant: "success-soft-outline",
    subTitle: "Sales Dashboard",
    menu: "sales",
  },
  {
    id: 4,
    icon: "user",
    name: "Accounts",
    link: "/home-marketing",
    variant: "danger-soft-outline",
    subTitle: "Accounts Dashboard",
    menu: "accounts",
  },
  {
    id: 5,
    icon: "building",
    name: "Inventory",
    link: "/inventory-dashboard",
    variant: "warning-soft-outline",
    subTitle: "Inventory Dashboard",
    menu: "inventory",
  },
  {
    id: 6,
    icon: "reports",
    name: "Reports",
    link: "/report-dashboard",
    variant: "info-soft-outline",
    subTitle: "Reports Dashboard",
    menu: "reports",
  },
];
